import { Action, createReducer, on } from '@ngrx/store';
import { getFAQSuccessAction, getPrivacyPolicySuccessAction, getTermsAndConditionsSuccessAction } from './terms-and-conditions.actions';
import { TermsAndConditionsState } from './terms-and-conditions.state';

const initialState = new TermsAndConditionsState();

const reducer = createReducer(
  initialState,
  on(getTermsAndConditionsSuccessAction, (state, { termsAndConditions: termsAndConditions }) => ({
    ...state,
    termsAndConditionsContent: termsAndConditions,
  })),
  on(getFAQSuccessAction, (state, payload) => ({
    ...state,
    faqContent: payload.faq,
  })),
  on(getPrivacyPolicySuccessAction, (state, payload) => ({
    ...state,
    privacyPolicyContent: payload.privacyPolicy,
  }))
);

export function termsAndConditonsReducer(state: TermsAndConditionsState | null, action: Action) {
  return reducer(state, action);
}
